module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm12",
    attrs: {
      "id": "page_21"
    }
  }, [_c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm13"
  }, [_vm._v("The story of this book is true, and chief of the failures in the making of the book is this, that it is not all the truth. The light is not bright enough, the shadow is not black enough to give a true picture of that bit of Western life of which the writer was some small part. The men of the book are still there in the mines and lumber camps of the mountains, fighting out that eternal fight for manhood, strong, clean, God-conquered. And, when the west winds blow, to the open ear the sounds of battle come, telling the fortunes of the fight.")]), _vm._v(" "), _c('p', {
    staticClass: "fm13"
  }, [_vm._v("Because a man's life is all he has, and because the only hope of the brave young West lies in its men, this story is told. It may be that the tragic pity of a broken life may move some to pray, and that that divine power there is in a single brave heart to summon forth hope and courage may move some to fight. If so, the tale is not told in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "fm15"
  }, [_vm._v("C.W.G."), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\nWinnipeg, Canada, 1898")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ac81ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0008.vue
// module id = 84
// module chunks = 0